import * as React from "react";
import { styled } from "@mui/system";
import MUIFab from "@mui/material/Fab";
import { FabProps as FabPropsMUI } from "@mui/material/Fab";
export interface FabProps extends FabPropsMUI {
  component?: React.ElementType;
}

const FabRoot = styled(MUIFab, {
  name: "Fab",
  slot: "Root",
  overridesResolver: (props, styles) => []
})(({ theme }) => ({
  "&.MuiButtonBase-root": {
    color: theme.palette.primary.baseWhiteColor,
    background: theme.palette.primary.primaryBackgroundDefault,

    "&:hover,&:active,&:focus": {
      background:
        "linear-gradient(140deg, " +
        theme.palette.primary.primaryBackgroundHover +
        " 100%, " +
        theme.palette.primary.primaryBackgroundHover +
        " 100%)",
      color: theme.palette.primary.baseWhiteColor
    },
    "&.Mui-disabled ": {
      background: theme.palette.primary.primaryBackgroundDisabled,
      color: theme.palette.primary.baseWhiteColor,
      textShadow: "none"
    },
    "&.MuiFab-circular.MuiFab-sizeMedium": {
      height: 48,
      width: 48,
      "& .MuiSvgIcon-root": {
        fontSize: 24
      }
    },
    "&.MuiFab-circular.MuiFab-sizeSmall": {
      height: 38,
      width: 38,
      "& .MuiSvgIcon-root": {
        fontSize: 18
      }
    },
    "&.MuiFab-circular.MuiFab-sizeLarge": {
      height: 56,
      width: 56,
      "& .MuiSvgIcon-root": {
        fontSize: 24
      }
    }
  }
}));

export const Fab = React.forwardRef<HTMLButtonElement, FabProps>(function Fab(
  props,
  ref
) {
  return <FabRoot {...props} ref={ref} />;
});
